import { useAuth } from '@/contexts/AuthContext';
import { SUPER_ADMIN_EMAILS } from '@/constants/admin';

export function useIsSuperAdmin() {
  const { user, loading } = useAuth();
  const isSuperAdmin = !!user?.email && SUPER_ADMIN_EMAILS.includes(user.email);
  return { isSuperAdmin, loading };
}
